export const REWARD_PENALTIES_ROUTE = '/rewards'
export const BOOKING_ROUTE = '/bookings'
export const CREATE_BOOKING_ROUTE = '/bookings/create'

export const ADD_PARTNER_ROUTE = '/partners'
export const WORKER_INFO_ROUTE = '/workers'
